(function () {
  'use strict';
  if (window.__myxBackgroundRemovalSizing) return;
  window.__myxBackgroundRemovalSizing = true;

  // CPB keeps the original URL for undo/order artwork. Resize only the copy
  // sent to its background-removal service, which rejects inputs over 50 MP.
  var endpoint = 'https://app.thecustomproductbuilder.com';
  var requests = new WeakMap(), copies = new Map();
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  var nativeHeader = XMLHttpRequest.prototype.setRequestHeader;
  var nativeAbort = XMLHttpRequest.prototype.abort;
  function isRemoval(method, address) {
    try {
      var url = new URL(address, location.href);
      return String(method).toUpperCase() === 'POST' && url.origin === endpoint && /^\/removeBgImage\/?$/i.test(url.pathname);
    } catch (_) { return false; }
  }
  function sourceImage(url) {
    return Array.from(document.querySelectorAll('#product-builder .cpb-upload-image img')).find(function (img) {
      return img.src === url && img.complete && img.naturalWidth;
    });
  }
  function loadImage(url, signal) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      function abort() { img.src = ''; finish(new Error('Image preparation cancelled.')); }
      function finish(error) {
        signal.removeEventListener('abort', abort);
        img.onload = img.onerror = null;
        if (error) reject(error); else resolve(img);
      }
      img.crossOrigin = 'anonymous';
      img.onload = function () { finish(); };
      img.onerror = function () { finish(new Error('Image preparation failed.')); };
      signal.addEventListener('abort', abort, { once: true });
      if (signal.aborted) return abort();
      img.src = url;
    });
  }
  async function processingCopy(url, request) {
    if (copies.has(url)) return copies.get(url);
    var signal = request.controller.signal;
    var original = sourceImage(url) || await loadImage(url, signal);
    var width = original.naturalWidth, height = original.naturalHeight;
    if (Math.max(width, height) <= 4096 && width * height <= 12000000) return url;
    var scale = Math.min(1, 2048 / width, 2048 / height);
    var outWidth = Math.max(1, Math.round(width * scale));
    var outHeight = Math.max(1, Math.round(height * scale));
    var bitmap = null, canvas = document.createElement('canvas');
    try {
      if (window.createImageBitmap) {
        var response = await fetch(url, { signal: signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Could not read the uploaded image.');
        var blob = await response.blob();
        try {
          bitmap = await createImageBitmap(blob, { resizeWidth: outWidth, resizeHeight: outHeight, resizeQuality: 'high' });
        } catch (_) {
          if (signal.aborted) throw new Error('Image preparation cancelled.');
        }
        blob = null;
      }
      // A CORS-loaded image also works on browsers without resized bitmaps.
      if (!bitmap) original = await loadImage(url, signal);
      if (signal.aborted) throw new Error('Image preparation cancelled.');
      canvas.width = outWidth; canvas.height = outHeight;
      var context = canvas.getContext('2d');
      if (!context) throw new Error('Image preparation unavailable.');
      context.imageSmoothingEnabled = true; context.imageSmoothingQuality = 'high';
      context.drawImage(bitmap || original, 0, 0, outWidth, outHeight);
      var encoded = canvas.toDataURL('image/png').split(',')[1];
      var state = window.CPB && window.CPB.getStore().getState();
      var shopId = state && (state.App && state.App.shop && state.App.shop.id || state.Routing && state.Routing.shopId);
      var builder = document.getElementById('product-builder');
      if (!shopId || !builder) throw new Error('Upload service unavailable.');
      var form = new URLSearchParams();
      // CPB's private-image proxy requires its normalized shop filename prefix.
      var shopName = builder.getAttribute('data-shop-name').replace(/\.myshopify\.com$/i, '');
      var name = shopName + '-' + builder.getAttribute('data-product-id') + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12) + '.png';
      // Same single-chunk customer-image contract used by CPB's uploader.
      form.set('shopId', shopId); form.set('customPath', 'images/customers');
      form.set('file[originalname]', name); form.set('file[mimetype]', 'image/png');
      form.set('file[buffer]', encoded); form.set('file[index]', '0'); form.set('file[total]', '1');
      form.set('webpEnabled', 'false');
      var headers = Object.assign({}, request.headers);
      Object.keys(headers).forEach(function (key) { if (key.toLowerCase() === 'content-type') delete headers[key]; });
      headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      var uploaded = await fetch(endpoint + '/imageUpload', { method: 'POST', headers: headers, body: form.toString(), signal: signal, credentials: 'omit' });
      if (!uploaded.ok) throw new Error('Could not prepare the processing copy.');
      var result = (await uploaded.text()).trim();
      try { result = JSON.parse(result); } catch (_) {}
      if (typeof result !== 'string' || !/^https:\/\//i.test(result)) throw new Error('Invalid processing copy.');
      var checkedCopy = await loadImage(result, signal);
      if (checkedCopy.naturalWidth !== outWidth || checkedCopy.naturalHeight !== outHeight) throw new Error('Processing copy dimensions did not match.');
      if (copies.size >= 4) copies.delete(copies.keys().next().value);
      copies.set(url, result);
      document.documentElement.setAttribute('data-myx-bg-prepared', outWidth + 'x' + outHeight);
      return result;
    } finally {
      if (bitmap) bitmap.close();
      canvas.width = canvas.height = 1;
    }
  }
  XMLHttpRequest.prototype.open = function (method, address, async) {
    var previous = requests.get(this);
    if (previous && previous.controller) previous.controller.abort();
    requests.delete(this);
    if (async !== false && isRemoval(method, address)) requests.set(this, { headers: {}, controller: null });
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
    var request = requests.get(this);
    if (request) request.headers[name] = value;
    return nativeHeader.apply(this, arguments);
  };
  XMLHttpRequest.prototype.abort = function () {
    var request = requests.get(this);
    if (request && request.controller) request.controller.abort();
    requests.delete(this);
    return nativeAbort.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, request = requests.get(xhr), data;
    if (!request || typeof body !== 'string') return nativeSend.apply(xhr, arguments);
    try { data = JSON.parse(body); } catch (_) { return nativeSend.apply(xhr, arguments); }
    if (!data || typeof data.fileUrl !== 'string' || !/^https?:\/\//i.test(data.fileUrl)) return nativeSend.apply(xhr, arguments);
    request.controller = new AbortController();
    var timer = setTimeout(function () { request.controller.abort(); }, 30000);
    processingCopy(data.fileUrl, request).then(function (url) {
      data.fileUrl = url;
    }).catch(function () {
      // Let CPB's existing failure/retry handling remain in charge if preparation
      // is unavailable. Never replace the customer's original artwork on failure.
    }).finally(function () {
      clearTimeout(timer);
      if (requests.get(xhr) !== request || xhr.readyState !== 1) return;
      nativeSend.call(xhr, JSON.stringify(data));
    });
  };
}());
